import { Pipe, PipeTransform } from '@angular/core';
import { GameService, UserService } from '@core/services';
import { TriviaGame } from '@core/models';

@Pipe({
  name: 'roundImage',
  standalone: true,
})
export class RoundImagePipe implements PipeTransform {
  constructor(
    private gameService: GameService,
    private userService: UserService,
  ) {}

  transform(
    questionStarted: boolean,
    gameScreen: string,
    game?: TriviaGame,
  ): string {
    let splashScreenIndex = this.gameService.splashScreenIndex.value + 1;
    let roundsCount =
      this.gameService.game.value.trivia_game?.trivia_game_rounds_length;
    const activeRoundIndex =
      this.gameService.gameplayState.value.activeRoundIndex;
    const isCtGame = game?.trivia_game?.game_template_id === 'ct';
    const isNeedDifferentADs =
      this.userService.user.user_id ===
        '897bc9b1-5180-4633-8635-894bbd11f777' ||
      this.userService.user.manager_id ===
        '897bc9b1-5180-4633-8635-894bbd11f777';
    // const isNeedDifferentADs = this.userService.user.user_id === '32587674-16fb-4660-9ef2-f6f03685cc7c';

    if (this.gameService.gameScreen.value === 'bonusSplash') {
      return 'assets/images/bonus-round.png';
    }

    if (this.gameService.gameScreen.value === 'survey') {
      if (isNeedDifferentADs) {
        return 'assets/images/add-placeholder.png';
        // return 'assets/ads/Defender_5.jpg';
      }
      return 'assets/images/feedback.png';
    }

    if (questionStarted) {
      if (isNeedDifferentADs) {
        return 'assets/images/add-placeholder.png';
        // let returnValue: string;
        // switch (isCtGame ? Math.floor(activeRoundIndex / 2) : activeRoundIndex) {
        //   case 0:
        //     returnValue = 'assets/ads/Defender_1.jpg';
        //     break;
        //   case 1:
        //     returnValue = 'assets/ads/Defender_2.jpg';
        //     break;
        //   case 2:
        //     returnValue = 'assets/ads/Defender_3.jpg';
        //     break;
        //   case 3:
        //     returnValue = 'assets/ads/Defender_4.jpg';
        //     break;
        // }
        // return returnValue;
      }
      return 'assets/images/add-placeholder.png';

      // return 'assets/images/add-' + (isCtGame ? Math.floor(activeRoundIndex / 2) : activeRoundIndex) + '.png';
    }
    if (this.gameService.gameScreen.value === 'wager') {
      if (
        this.gameService.game.value?.trivia_game?.game_template_id === 'ctm' ||
        isCtGame
      ) {
        if (activeRoundIndex < roundsCount - 1) {
          return 'assets/images/wager-10.png';
        } else {
          return 'assets/images/wager-20.png';
        }
      } else {
        return 'assets/images/wager-40.png';
      }
    }
    if (isCtGame) {
      splashScreenIndex = Math.floor(splashScreenIndex / 2) + 1;
      roundsCount = Math.floor(roundsCount / 2) + 1;
    }
    if (splashScreenIndex === roundsCount) {
      return 'assets/images/final-round.png';
    }

    return 'assets/images/round-' + splashScreenIndex + '.png';
  }
}
